import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center break-words bg-shade-white" }

import { defineAsyncComponent, onMounted } from 'vue'
import { useAuthStore } from '@shared/stores/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogOut',
  setup(__props) {

const BodyText = defineAsyncComponent(() => import('@shared/design-system/components/Typography/BodyText.vue'))

const authStore = useAuthStore()

onMounted(async () => await authStore.logoutAndRedirect())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BodyText), {
      size: "large",
      class: "font-bold"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Logging out ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})